export const LAYOUT_NAVBAR_WIDTH = "18rem";
export const LAYOUT_NAVBAR_WIDTH_COLLAPSED = "3rem";
export const LAYOUT_NAVBAR_WIDTH_ASIDE = "60vw";
export const LAYOUT_HEADER_HEIGHT = "4rem";
export const APP_LOGO_HEIGHT = "4rem";
export const APP_LOGO_HEIGHT_MOBILE = "3.2rem";
